import React, { useContext, useEffect } from 'react'
import ColorContext from '../providers/ColorContainer'

function BgColorContainer({ children, disable }) {
    const { setBgColor } = useContext(ColorContext);

    useEffect(() => {
        if (!disable) {
            setBgColor("black");
        }
    }, [setBgColor, disable]);

    return (
        <div>
            {children}
        </div>
    );
}

export default BgColorContainer;
